<template>
  <div id="app">
    <div id="content" class="addedit-person">
      <!-- HEADER -->
      <Header
        :page="'campus_training'"
        :title_one="'campus_training'"
        :action_one="doc_ok ? 'update' : ''"
        :action_two="doc_ok ? 'cancel' : ''"
        :banner_docsok_msg="doc_ok"
        @update="validate()"
      ></Header>

      <ErrorPopup
        @close="closePopup2()"
        @input="closePopup2()"
        :dialog="dialog2"
        :message="message"
      ></ErrorPopup>

      <div
        class="description"
        v-html="$t('descriptions.campus_training')"
      ></div>

      <v-container fluid grid-list-md>
        <v-layout row wrap>
          <div class="box">
            <v-flex xs12>
              <div class="item expanded">
                <v-flex xs12 v-for="(item, index) in persons">
                  <v-layout
                    row
                    wrap
                    class="box mobile-box"
                    style="margin-bottom: -10px"
                  >
                    <v-flex xs6 md3 style="margin-bottom: 0px">
                      <input
                        type="text"
                        v-model="item.name"
                        autocomplete="new-text"
                        :placeholder="$t('params.name')"
                      />
                    </v-flex>
                    <v-flex xs6 md3 style="margin-bottom: 0px">
                      <input
                        type="text"
                        v-model="item.surname"
                        autocomplete="new-text"
                        :placeholder="$t('params.surname')"
                      />
                    </v-flex>
                    <v-flex xs4 md3 style="margin-bottom: 0px">
                      <input
                        type="text"
                        v-model="item.dni"
                        autocomplete="new-text"
                        :placeholder="$t('params.dni')"
                      />
                    </v-flex>
                    <v-flex
                      xs2
                      md2
                      lg2
                      xl2
                      class="icon"
                      style="padding-top: 10px"
                    >
                      <v-icon
                        v-if="persons.length > 1"
                        @click="persons.splice(index, 1)"
                        >remove</v-icon
                      >
                      <v-icon
                        v-if="index == persons.length - 1"
                        @click="
                          persons.push({
                            name: '',
                            dni: '',
                          })
                        "
                        >add</v-icon
                      >
                    </v-flex>
                  </v-layout>
                </v-flex>
              </div>
            </v-flex>
          </div>
          <ErrorPopup
            @close="closePopup()"
            @input="closePopup()"
            :dialog="dialog"
          ></ErrorPopup>
        </v-layout>
      </v-container>
    </div>
  </div>
</template>

<script>
import i18n from "@/i18n";
import ErrorPopup from "@/components/ui/ErrorPopup.vue";
import Header from "@/components/layout/Header";

export default {
  name: "CampusPersonEdit",
  components: {
    ErrorPopup,
    Header,
  },
  data() {
    return {
      persons: [{ name: "", dni: "" }],
      is_virtual: false,
      dialog: false,
      dialog2: false,
      message: "",
      doc_ok: true,
    };
  },
  computed: {
    user() {
      return this.$store.getters["user/getUser"];
    },

    event() {
      return this.$store.getters.getCurrentEvent();
    },
  },
  created() {
    // save campus
    this.$store.commit("setCampus", true);

    // get player information
    var self = this;

    this.$store
      .dispatch("person/loadPersonCampus", {
        campus_id: this.user.event_id,
        participant_id: this.user.participant_id,
      })
      .then(function () {
        // save player information
        let person = self.$store.getters["person/getPerson"];
        // save information
        if (
          (!person.antithermal && [4, 5].includes(self.event.type_id)) ||
          !person.medicines ||
          !person.externals ||
          !person.image_right
        ) {
          self.dialog2 = true;
          self.doc_ok = false;
          self.message = "campus.errors.documents.required_2";
        }

        if (person.info_training)
          self.persons = JSON.parse(person.info_training);
      });
  },
  methods: {
    refresh() {
      this.$forceUpdate();
    },
    validate() {
      let validate =
        this.persons.filter(
          (p) =>
            p.name.trim() != "" && p.surname.trim() != "" && p.dni.trim() != ""
        ).length == this.persons.length;

      if (validate) {
        var self = this;
        var params = {
          info_training: JSON.stringify(
            self.persons.filter((p) => p.name.trim() != "")
          ),
        };

        // update player
        self.$store
          .dispatch("person/campusUpdateTraining", {
            campus_id: self.user.event_id,
            participant_id: self.user.participant_id,
            input: params,
          })
          .then(function () {
            self.campus_home();
          });
      } else {
        this.dialog = true;
      }
    },

    closePopup() {
      this.dialog = false;
    },

    closePopup2() {
      this.dialog2 = false;
    },

    campus_home() {
      this.$router
        .push({
          name: "campus_home",
          params: { campus_id: this.user.event_id },
        })
        .catch((err) => {});
    },
  },
  watch: {},
  mounted() {},
};
</script>

<style lang="scss">
#content.addedit-person {
  .box {
    width: 100% !important;
    max-width: 900px;
    margin: 0 auto;
    margin-top: 25px !important;

    .message.input-error {
      color: $warning-color;
    }

    .upper {
      text-transform: uppercase;
      &::placeholder {
        text-transform: none;
      }
    }

    /* Alergy */
    .v-menu__content {
      margin-top: 43px;
    }

    .item {
      width: 50%;
      margin: 0px 0px 20px 0px;
      padding: 0 15px;
      display: inline-block;

      &.expanded {
        width: 100% !important;
      }

      label {
        font-size: 14px;
        padding: 0;
        margin: 2px 0;
        display: block;
        font-weight: bold;

        a {
          text-decoration: underline;
          cursor: pointer;
          font-weight: bold;
        }

        span.info {
          font-weight: bold;
          color: #fc8926 !important;
        }
      }

      .v-radio {
        margin-right: 15px;
      }

      .v-input {
        margin-top: 0;
      }
      .v-input__slot {
        margin-bottom: 0;
      }

      input,
      select,
      .v-autocomplete .v-input__slot,
      .v-select {
        width: 100%;
        padding: 10px;
        // margin-bottom: 5px;
        border: 1px solid $secondary-color;
        outline: none;
        font-size: 16px;
        border-radius: 3px;
        color: $dark-color;

        &::placeholder {
          color: $dark-color;
          opacity: 0.5;
        }
      }

      // input:disabled, select:disabled, .v-input--is-disabled {
      //   @include opacity(0.3);
      // }

      .v-autocomplete {
        margin-top: 0;
        padding-top: 0;

        .v-input__control {
          .v-input__slot {
            margin: 0;
            padding: 4px;

            &:after,
            &:before {
              content: "";
              border: none !important;
            }
          }
          .v-select__slot {
            border: none;

            input {
              border: none;
              margin: 0;
            }
          }
        }
      }

      .obligatory {
        color: $alert-color;
        font-weight: bold;
        font-size: 16px;

        &.error {
          display: block;
        }
      }

      .input-error {
        border: 1px solid;
        border-color: $alert-color !important;
        &::placeholder {
          color: $alert-color !important;
          opacity: 0.5;
        }
        .v-input__slot {
          border-color: $alert-color;
        }
      }

      .readonly {
        cursor: not-allowed;
      }

      input:disabled,
      select:disabled {
        background-color: #ddd;
        cursor: not-allowed;
        @include opacity(0.5);
      }
    }

    .error {
      border-color: red !important;

      &::placeholder {
        color: $alert-color !important;
        opacity: 1;
      }

      .v-input__slot {
        border-color: $alert-color;
      }

      .vti__input {
        border-color: red !important;
      }
    }

    .date-picker.error {
      input {
        border: 1px solid red;
      }
    }

    #medicamento,
    #alergy {
      input[type="text"],
      select,
      .v-select {
        display: inline-block;
        width: calc(100% - 40px);
      }

      .checkbox {
        display: inline-block;
        width: 40px;
        height: 40px;
      }
    }
    #alergy {
      ::before {
        display: none;
      }

      .v-select .v-input__slot {
        padding: 6px;
        height: 42px;
      }

      .v-chip .v-chip__content {
        height: 26px;
      }

      .v-text-field__details {
        display: none !important;
      }

      .v-input {
        width: 100% !important;
      }

      input {
        border: none;
      }

      .v-input__control {
        padding: 0;
      }

      .v-input__slot {
        height: auto !important;
      }
    }

    #birthday {
      .error {
        input {
          border: 1px solid red;
        }
      }
    }

    #country,
    #nacionality {
      .v-select {
        padding: 0;
      }
      .v-autocomplete {
        border: none;
      }
    }

    select {
      background-image: url("/img/sort-down.svg");
      background-size: 10px;
      background-position: right 10px center;
      background-repeat: no-repeat;
    }

    select option {
      font-size: 14pt;
    }

    button.btn {
      max-width: 300px;
      width: 100%;
      padding: 15px;
      outline: none;
      border: none;
      cursor: pointer;
      font-size: 12pt;
      font-family: Speedee-Bold;
      margin-top: 25px;
      border-radius: 3px;
      border: 1px solid $secondary-color;
      text-transform: uppercase;
      transition: all 0.5s;
      background: #222;
      color: $secondary-color;

      &:hover {
        background: $main-color;
      }
    }

    .form-subtitle {
      margin-top: 36px;
      background: #eee;
      padding: 7px;

      &:first-of-type {
        margin-top: 12px;
      }
    }
  }
}

@include media("<=desktop") {
  #content.addedit-person {
    .box {
      width: 100%;
      padding: 0;
      margin: 0;

      .item {
        width: 100%;
        display: block;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.actions {
  padding: 25px;
  margin: 0 auto;
  margin-bottom: 25px;
  text-align: center;

  .btn {
    width: calc(50% - 20px);
    margin: 0 10px;
    display: inline-block;
    min-width: 40px;
    padding: 0 35px;
    outline: none;
    border: none;
    cursor: pointer;
    text-align: center;
    font-size: 16px;
    border-radius: 3px;
    -webkit-transition: all 0.5s;
    transition: all 0.5s;
    background-color: #172654;
    color: #fff;
    height: 40px;
    line-height: 40px;
    text-transform: uppercase;
    background-color: #fc8926;
    font-family: AvantGarde-Bold;
    max-width: 300px;
    transition: background-color 0.5s ease;

    &#addedit {
      border: 1px solid #fc8926;

      &:hover {
        background-color: #e78026;
        border-color: #e78026;
      }
    }

    &#cancel {
      background-color: transparent;
      color: #c55c00;
      border: 1px solid #fc8926;

      &:hover {
        background-color: #fc8a2623 !important;
      }
    }
  }
}

@include media("<=desktop") {
  .actions {
    padding: 25px 0px;

    .btn {
      padding: 0 15px;
    }
  }
}
</style>
